import React from 'react';

const IconBehance = () => (
    <svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="-1 0 20 12">
        <title>Youtube</title>
        <path xmlns="http://www.w3.org/2000/svg" d="M14.2616 0.631348H3.73837C1.67372 0.631348 0 2.30507 0 4.36972V9.63023C0 11.6949 1.67372 13.3686 3.73837 13.3686H14.2616C16.3263 13.3686 18 11.6949 18 9.63023V4.36972C18 2.30507 16.3263 0.631348 14.2616 0.631348ZM11.7334 7.25592L6.81133 9.60345C6.68017 9.666 6.52868 9.57038 6.52868 9.42509V4.5833C6.52868 4.43594 6.68415 4.34043 6.81558 4.40704L11.7377 6.90131C11.884 6.97546 11.8815 7.18532 11.7334 7.25592Z" fill="#444958" stroke="#444958" />
    </svg>
);

export default IconBehance;
